import { cleanParagraphTags } from "@talladega/helpers";

type Props = {
  title: string;
  description: string;
};

export const FormContentHeader = ({ title, description }: Props) => {
  return (
    <>
      {/* eslint-disable react/no-danger */}
      <h5
        className="text-2xl lg:text-4xl lg:tracking-tight"
        dangerouslySetInnerHTML={{ __html: cleanParagraphTags(title) }}
      />
      <p
        className="text-lg font-normal"
        dangerouslySetInnerHTML={{ __html: cleanParagraphTags(description) }}
      />
      {/* eslint-enable */}
    </>
  );
};

export default {};
